// =============================================================================
// search-fold.ts — Pliage d'une chaîne pour une recherche insensible à la casse ET aux accents.
// =============================================================================
// Le dépôt portait DÉJÀ quatre copies locales de cette fonction (catalogue fournisseur, FAQ, « Mes
// collaborateurs », campagnes fournisseur), toutes identiques au détail près : NFD + suppression des
// diacritiques + minuscules. Le composant partagé `FilterCombo` en a besoin à son tour ; plutôt qu'une
// cinquième copie, la fonction est factorisée ici. Les quatre copies existantes sont laissées en place
// dans CE lot (aucun écran n'est touché) et seront ramenées sur cette fonction au câblage du lot F1.
//
// `toLocaleLowerCase('fr')` plutôt que `toLowerCase()` : la casse turque (İ/ı) ne doit pas décider du
// résultat d'une recherche française. `\p{Diacritic}` exige le drapeau `u`.

/**
 * Plie une chaîne pour la comparer : « Élite Sécurité » et « elite securite » donnent le même résultat.
 * Espaces de bord retirés (une frappe qui finit par un espace ne doit rien exclure).
 */
export function foldSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLocaleLowerCase('fr')
    .trim();
}

/**
 * Vrai si `haystack` contient `needle` au sens plié. Une requête vide matche TOUT : un champ de
 * recherche vierge n'est pas un filtre.
 */
export function matchesSearch(haystack: string, needle: string): boolean {
  const folded = foldSearch(needle);
  return folded === '' || foldSearch(haystack).includes(folded);
}
